{
  "tabs": {
    "chat": "Chat",
    "reminders": "Rappel",
    "calendar": "Kalandriye",
    "settings": "Anviwònman"
  },
  "common": {
    "cancel": "Anile",
    "save": "Sove",
    "confirm": "Konfime",
    "delete": "Efase",
    "back": "Retounen",
    "close": "Fèmen",
    "edit": "Modifye",
    "search": "Chèche",
    "all": "Tout",
    "loading": "Chaje...",
    "error": "Gen yon erè",
    "notFound": "Pa jwenn",
    "tryAgain": "Tanpri eseye ankò",
    "retry": "Reeseye",
    "undo": "Anile",
    "pullToRefresh": "Rale pou rafrechi",
    "justNow": "kounye a"
  },
  "auth": {
    "welcome": "Byenveni nan FishMemory",
    "tagline": "Asistan rapèl WhatsApp ou, kounye a nan pòch ou.",
    "subtitle": "Asistan rapèl WhatsApp ou, kounye a nan pòch ou.",
    "phoneLabel": "Nimewo WhatsApp ou",
    "phoneHint": "N ap voye yon kòd verifikasyon atravè WhatsApp",
    "invalidPhone": "Tanpri antre yon nimewo telefòn valab",
    "continue": "Kontinye",
    "enterPhone": "Antre nimewo WhatsApp ou",
    "phonePlaceholder": "Nimewo telefòn",
    "sendCode": "Voye Kòd",
    "verifyTitle": "Verifye nimewo ou",
    "otpSentTo": "Yon kòd 6 chif te voye bay {{phone}} atravè WhatsApp",
    "enterFullCode": "Tanpri antre tout 6 chif yo",
    "invalidOtp": "Kòd pa valab. Tanpri eseye ankò.",
    "otpFailed": "Echwe pou voye kòd la. Eseye ankò.",
    "otpResent": "Kòd voye ankò",
    "resendIn": "Voye ankò nan {{seconds}}s",
    "resendCode": "Voye kòd ankò",
    "enterOtp": "Antre kòd ki voye sou WhatsApp ou",
    "verify": "Verifye",
    "resend": "Voye kòd ankò",
    "wrongNumber": "Nimewo pa kòrèk?",
    "backToPhone": "Retounen nan nimewo",
    "editPhone": "Modifye nimewo telefòn",
    "error": "Erè",
    "setupTitle": "Ann mete tout an plas",
    "setupSubtitle": "Ou ka toujou chanje sa pita nan Anviwònman",
    "namePlaceholder": "Non ou",
    "letsGo": "Fini konfigirasyon",
    "skipForNow": "Sote pou kounye a"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Ekri yon mesaj...",
    "inputPlaceholder": "Ekri yon mesaj...",
    "typing": "FishMemory ap ekri...",
    "online": "Sou entènèt",
    "connecting": "Ap konekte...",
    "reconnecting": "Ap rekonekte...",
    "offline": "Offline",
    "empty": "Kòmanse yon konvèsasyon",
    "emptyHint": "Kreye rapèl, tcheke orè ou, oswa mande èd.",
    "emptyAction": "Voye yon rapèl egzanp",
    "actions": "Aksyon chat",
    "keep": "Kenbe mesaj",
    "clearTitle": "Efase chat",
    "clearConfirm": "Efase tout mesaj sou aparèy sa a? Sa pa ka defèt.",
    "clear": "Efase chat",
    "optionSelected": "Chwazi: {{label}}",
    "sendingSelection": "Ap voye...",
    "connectionLost": "Ap rekonekte..."
  },
  "reminders": {
    "title": "Rappel mwen yo",
    "active": "Aktif",
    "today": "Jodi a",
    "thisWeek": "Semèn sa a",
    "history": "Istwa",
    "items": "atik",
    "emptyTitle": "Pa gen rapèl ankò",
    "emptySubtitle": "Kreye youn nan chat epi li ap parèt isit la.",
    "emptyAction": "Louvri chat",
    "filterActive": "Aktif",
    "filterToday": "Jodi a",
    "filterWeek": "Semèn sa a",
    "filterHistory": "Istwa",
    "emptyState": "Pa gen rapèl ankò. Kòmanse chat!",
    "swipeDone": "Fini",
    "swipeSnooze": "Rete tann",
    "swipeDelete": "Efase",
    "search": "Chèche rapèl...",
    "upcoming": "Kap vini",
    "completed": "Fini",
    "overdue": "Anreta",
    "tomorrow": "Demèn",
    "synced": "Senkronize {{value}}",
    "swipeHint": "Glise yon rapèl pou plis aksyon",
    "noResults": "Pa gen rapèl ki koresponn ak rechèch ou",
    "noResultsHint": "Eseye yon lòt mo kle oswa efase rechèch la",
    "deleteAllFailed": "Echwe efase tout rapèl yo"
  },
  "calendar": {
    "title": "Kalandriye",
    "today": "Jodi a",
    "tomorrow": "Demèn",
    "completed": "fini",
    "noEvents": "Pa gen anyen pwograme",
    "noEventsSubtitle": "Chwazi yon dat pou wè rapèl ak evènman kalandriye.",
    "googleEvent": "Google Kalandriye",
    "legendActive": "Aktif",
    "legendRecurring": "Repete",
    "legendDone": "Fini",
    "legendGoogle": "Google",
    "previousMonth": "Mwa anvan",
    "nextMonth": "Mwa pwochen",
    "previousYear": "Ane anvan",
    "nextYear": "Ane pwochen",
    "goToToday": "Ale jodi a",
    "all": "Tout",
    "active": "Aktif",
    "done": "Fini",
    "paused": "Kanpe"
  },
  "settings": {
    "title": "Anviwònman",
    "profile": "Pwofil",
    "name": "Non afichaj",
    "enterName": "Antre non ou",
    "language": "Lang",
    "uiLanguage": "Lang app",
    "uiLanguageHelp": "Chanje lang UI app, etikèt kalandriye, ak direksyon layout sou aparèy sa a sèlman.",
    "serverLanguage": "Lang chat",
    "serverLanguageHelp": "Chanje lang repons sèvè ak mesaj rapèl pou kont ou.",
    "timezone": "Zòn tan",
    "currentTimezone": "Zòn tan aktyèl",
    "timezoneHelp": "Tout lè rapèl montre dapre zòn tan sa a.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Sove zòn tan",
    "timezoneSaved": "Zòn tan mete ajou",
    "detect": "Detekte",
    "detectFailed": "Pa kapab detekte zòn tan",
    "autoDetect": "Detekte otomatikman ak GPS",
    "notifications": "Notifikasyon",
    "notificationsHelp": "Rapèl swivi kontwole alèt repete apre yon rapèl delivre. Otorizasyon notifikasyon aparèy toujou jere nan anviwònman telefòn ou.",
    "pushEnabled": "Notifikasyon pouse",
    "autoDoneOnFire": "Make otomatikman fini lè li pibliye",
    "autoDoneOnFireDesc": "Lè li etenn, rapèl rete aktif jiskaske ou make yo fini.",
    "googleCalendar": "Google Kalandriye",
    "google": "Google Kalandriye",
    "googleConnected": "Konekte",
    "googleDisconnected": "Pa konekte",
    "googleConnectedHelp": "Nouvo rapèl ka senkronize otomatikman nan kalandriye ou.",
    "googleDisconnectedHelp": "Konekte Google Kalandriye pou kenbe rapèl ak evènman an liy.",
    "googleConnectFailed": "Echwe konekte Google Kalandriye",
    "connected": "Konekte",
    "disconnected": "Pa konekte",
    "connect": "Konekte",
    "disconnect": "Dekonekte",
    "autoSync": "Senkronize nouvo rapèl otomatikman",
    "autosync": "Senkronize nouvo rapèl otomatikman",
    "subscription": "Abònman",
    "trialUsed": "Esè: {{used}}/{{total}} itilize",
    "trialStatus": "Esè disponib",
    "activeStatus": "Abònman aktif",
    "expiredStatus": "Abònman ekspire",
    "unsubscribedStatus": "Pa abòne",
    "about": "Sou",
    "version": "Vèsyon",
    "logout": "Dekonekte",
    "logoutTitle": "Dekonekte",
    "logoutConfirm": "Èske ou sèten ou vle dekonekte?",
    "noName": "Pa gen non mete",
    "serverConnection": "Koneksyon sèvè",
    "serverUrl": "URL sèvè",
    "serverEdit": "Modifye",
    "saveReconnect": "Sove epi rekonekte",
    "resetDefault": "Reyajiste default",
    "invalidServerUrlTitle": "URL sèvè pa valab",
    "invalidServerUrlMessage": "Antre yon URL sèvè http oswa https valab, pa egzanp https://example.com",
    "uiLanguageChangeFailed": "Echwe chanje lang app la. Tanpri eseye ankò.",
    "serverLanguageChangeFailed": "Echwe chanje lang chat la. Tanpri eseye ankò.",
    "timezoneChangeFailed": "Echwe chanje zòn tan an. Tanpri eseye ankò.",
    "autoSyncChangeFailed": "Echwe mete ajou senk otomatik. Tanpri eseye ankò.",
    "nameChangeFailed": "Echwe mete ajou non afichaj la. Tanpri eseye ankò.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Detay rapèl",
    "editTime": "Modifye lè",
    "rename": "Chanje non",
    "snooze": "Rete tann",
    "snooze15": "Rete tann 15 minit",
    "pause": "Kanpe",
    "pauseReminder": "Kanpe rapèl",
    "resume": "Kontinye",
    "resumeReminder": "Kontinye rapèl",
    "skip": "Sote pwochen",
    "skipOccurrence": "Sote okazyon sa a",
    "syncGoogle": "Senkronize ak Google",
    "delete": "Efase",
    "deleteTitle": "Efase Rapèl",
    "deleteConfirm": "Rapèl sa a ap efase nèt ale.",
    "deleteRecurringTitle": "Efase Rapèl Repete",
    "deleteRecurringMessage": "Èske ou vle sote okazyon sa a oswa efase tout seri a?",
    "deleteThisOccurrence": "Sote okazyon sa a",
    "deleteEntireSeries": "Efase tout seri a",
    "done": "Fini",
    "markDone": "Make kòm fini",
    "undo": "Retabli",
    "undoPrompt": "Bezwen li aktif ankò? Retabli li kounye a.",
    "recurring": "Repete",
    "nextRun": "Pwochen kouri",
    "oneTime": "Yon sèl fwa",
    "pending": "An atant",
    "sent": "Voye",
    "paused": "Kanpe",
    "active": "Aktif",
    "snoozed": "Rete tann",
    "localTime": "Montre nan lè lokal ou",
    "recurrence": "Repete",
    "created": "Kreye",
    "tags": "Tags",
    "fireCount": "Kantite fwa pibliye",
    "actions": "Aksyon",
    "none": "Okenn",
    "snoozeFailed": "Echwe pou rete tann rapèl",
    "pauseFailed": "Echwe pou kanpe rapèl",
    "resumeFailed": "Echwe pou kontinye rapèl",
    "skipFailed": "Echwe pou sote rapèl",
    "doneFailed": "Echwe make rapèl kòm fini",
    "undoFailed": "Echwe retabli estati rapèl",
    "deleteFailed": "Echwe efase rapèl",
    "rescheduleTitle": "Replanifye?",
    "rescheduleMsg": "Rapèl sa a anreta. Èske ou ta renmen replanifye li?",
    "reschedule15": "Nan 15 minit",
    "reschedule60": "Nan 1 èdtan",
    "keepOverdue": "Kenbe jan li ye"
  },
  "onboarding": {
    "slide1Title": "Byenveni nan FishMemory",
    "slide1Sub": "Asistan pèsonèl rapèl ou — mache ak WhatsApp e fèt pou pòch ou.",
    "slide2Title": "Chat Natirèlman",
    "slide2Sub": "Ekri rapèl jan ou panse: \"Raple m rele manman demen a 3pm\" — nou okipe rès la.",
    "slide3Title": "Pa Janm Rate Anyen",
    "slide3Sub": "Resevwa notifikasyon alè, òganize ak tags, epi rete sou tèt tout sa ki enpòtan.",
    "getStarted": "Kòmanse",
    "next": "Pwochen",
    "firstReminderTitle": "Kreye premye rapèl ou!",
    "firstReminderHint": "Eseye ekri yon bagay tankou:",
    "firstReminderExample": "Raple m bwè dlo demen a 9 AM",
    "gotIt": "Mwen konprann!",
    "notifRationaleTitle": "Rete Alè",
    "notifRationaleBody": "FishMemory bezwen notifikasyon pou raple ou alè. Ou pral sèlman resevwa alèt pou rapèl ou kreye.",
    "notifRationaleAllow": "Pèmèt Notifikasyon",
    "notifRationaleLater": "Petèt pita",
    "swipeHint": "Glise dwat pou aksyon rapid →",
    "calendarDragHint": "Trennen pou elaji ↕"
  }
}
